'use strict';

angular.module('amexReconciliationApp').filter('emphasis',
  function emphasize() {
    return function (text) {
      return '<span class="em-bold">' + text + '</span>';
    };
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/filters/emphasisFilter.js
// module id = 554
// module chunks = 0